const { createReducer } = require('../helpers')
const {
  GET_LOGGED_IN_USER,
  GET_LOGGED_IN_USER_SUCCESS,
  GET_LOGGED_IN_USER_ERROR,
  GET_LOGGED_IN_USER_RESET,

  FORGOT_PASSWORD,
  FORGOT_PASSWORD_SUCCESS,
  FORGOT_PASSWORD_ERROR,
  FORGOT_PASSWORD_RESET,

  POST_USER,
  POST_USER_SUCCESS,
  POST_USER_ERROR,
  POST_USER_RESET,

  IMPORT_USER,
  IMPORT_USER_SUCCESS,
  IMPORT_USER_ERROR,
  IMPORT_USER_RESET,

  BULK_UPDATE_USER,
  BULK_UPDATE_USER_SUCCESS,
  BULK_UPDATE_USER_ERROR,
  BULK_UPDATE_USER_RESET,

  GET_ALL_USERS,
  GET_ALL_USERS_SUCCESS,
  GET_ALL_USERS_ERROR,
  GET_ALL_USERS_RESET,

  GET_SINGLE_USER,
  GET_SINGLE_USER_SUCCESS,
  GET_SINGLE_USER_ERROR,
  GET_SINGLE_USER_RESET,

  UPDATE_USER,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_ERROR,
  UPDATE_USER_RESET,

  DELETE_USER,
  DELETE_USER_SUCCESS,
  DELETE_USER_ERROR,
  DELETE_USER_RESET,

  GET_ADMIN_DOCTORS_LIST,
  GET_ADMIN_DOCTORS_LIST_SUCCESS,
  GET_ADMIN_DOCTORS_LIST_ERROR,
  GET_ADMIN_DOCTORS_LIST_RESET,

  GET_ADMIN_DOCTOR,
  GET_ADMIN_DOCTOR_SUCCESS,
  GET_ADMIN_DOCTOR_ERROR,
  GET_ADMIN_DOCTOR_RESET,

  CREATE_ADMIN_DOCTOR,
  CREATE_ADMIN_DOCTOR_SUCCESS,
  CREATE_ADMIN_DOCTOR_ERROR,
  CREATE_ADMIN_DOCTOR_RESET,

  UPDATE_ADMIN_DOCTOR,
  UPDATE_ADMIN_DOCTOR_SUCCESS,
  UPDATE_ADMIN_DOCTOR_ERROR,
  UPDATE_ADMIN_DOCTOR_RESET,

  UPDATE_ADMIN_DOCTOR_STATUS,
  UPDATE_ADMIN_DOCTOR_STATUS_SUCCESS,
  UPDATE_ADMIN_DOCTOR_STATUS_ERROR,
  UPDATE_ADMIN_DOCTOR_STATUS_RESET,

  POST_ADMIN_DOCTOR_DIGITAL_SIG,
  POST_ADMIN_DOCTOR_DIGITAL_SIG_SUCCESS,
  POST_ADMIN_DOCTOR_DIGITAL_SIG_ERROR,
  POST_ADMIN_DOCTOR_DIGITAL_SIG_RESET,

  REVOKE_ADMIN_DOCTOR_DIGITAL_SIG,
  REVOKE_ADMIN_DOCTOR_DIGITAL_SIG_SUCCESS,
  REVOKE_ADMIN_DOCTOR_DIGITAL_SIG_ERROR,
  REVOKE_ADMIN_DOCTOR_DIGITAL_SIG_RESET,

  POST_ADMIN_DOCTOR_AUTH_PIN,
  POST_ADMIN_DOCTOR_AUTH_PIN_SUCCESS,
  POST_ADMIN_DOCTOR_AUTH_PIN_ERROR,
  POST_ADMIN_DOCTOR_AUTH_PIN_RESET,

  POST_ADMIN_DOCTOR_SPECS,
  POST_ADMIN_DOCTOR_SPECS_SUCCESS,
  POST_ADMIN_DOCTOR_SPECS_ERROR,
  POST_ADMIN_DOCTOR_SPECS_RESET,

  DELETE_ADMIN_DOCTOR,
  DELETE_ADMIN_DOCTOR_SUCCESS,
  DELETE_ADMIN_DOCTOR_ERROR,
  DELETE_ADMIN_DOCTOR_RESET,

  GET_ALL_ADMIN_PANEL_USERS,
  GET_ALL_ADMIN_PANEL_USERS_SUCCESS,
  GET_ALL_ADMIN_PANEL_USERS_ERROR,
  GET_ALL_ADMIN_PANEL_USERS_RESET,
  GET_SINGLE_ADMIN_PANEL_USER,
  GET_SINGLE_ADMIN_PANEL_USER_SUCCESS,
  GET_SINGLE_ADMIN_PANEL_USER_ERROR,
  GET_SINGLE_ADMIN_PANEL_USER_RESET,
  CREATE_ADMIN_PANEL_USER,
  CREATE_ADMIN_PANEL_USER_SUCCESS,
  CREATE_ADMIN_PANEL_USER_ERROR,
  CREATE_ADMIN_PANEL_USER_RESET,
  UPDATE_ADMIN_PANEL_USER,
  UPDATE_ADMIN_PANEL_USER_SUCCESS,
  UPDATE_ADMIN_PANEL_USER_ERROR,
  UPDATE_ADMIN_PANEL_USER_RESET,

  GET_PROFILE,
  GET_PROFILE_SUCCESS,
  GET_PROFILE_ERROR,
  GET_PROFILE_RESET,

  UPDATE_PROFILE,
  UPDATE_PROFILE_SUCCESS,
  UPDATE_PROFILE_ERROR,
  UPDATE_PROFILE_RESET,

  POST_DOC_DIGITAL_INFO,
  POST_DOC_DIGITAL_INFO_SUCCESS,
  POST_DOC_DIGITAL_INFO_ERROR,
  POST_DOC_DIGITAL_INFO_RESET,

  USER_LOGIN,
  USER_LOGIN_SUCCESS,
  USER_LOGIN_ERROR,
  USER_LOGIN_RESET,

  USER_REGISTRATION,
  USER_REGISTRATION_SUCCESS,
  USER_REGISTRATION_ERROR,
  USER_REGISTRATION_RESET,

  APPLE_LOGIN,
  APPLE_LOGIN_SUCCESS,
  APPLE_LOGIN_ERROR,
  APPLE_LOGIN_RESET,

  LOGIN_GOOGLE,
  LOGIN_GOOGLE_SUCCESS,
  LOGIN_GOOGLE_ERROR,
  LOGIN_GOOGLE_RESET,

  NUMBER_VALIDATION,
  NUMBER_VALIDATION_SUCCESS,
  NUMBER_VALIDATION_ERROR,
  NUMBER_VALIDATION_RESET,

  UPDATE_EMAIL,
  UPDATE_EMAIL_SUCCESS,
  UPDATE_EMAIL_ERROR,
  UPDATE_EMAIL_RESET,

  UPDATE_NUMBER,
  UPDATE_NUMBER_SUCCESS,
  UPDATE_NUMBER_ERROR,
  UPDATE_NUMBER_RESET,

  USER_LOGOUT,
  USER_LOGOUT_SUCCESS,
  USER_LOGOUT_ERROR,

  PASSWORD_CHANGE,
  PASSWORD_CHANGE_SUCCESS,
  PASSWORD_CHANGE_ERROR,
  PASSWORD_CHANGE_RESET,

  MARKETPLACE_PASSWORD_CHANGE,
  MARKETPLACE_PASSWORD_CHANGE_SUCCESS,
  MARKETPLACE_PASSWORD_CHANGE_ERROR,
  MARKETPLACE_PASSWORD_CHANGE_RESET,

  GET_DOCTOR_DETAILS,
  GET_DOCTOR_DETAILS_SUCCESS,
  GET_DOCTOR_DETAILS_ERROR,
  GET_DOCTOR_DETAILS_RESET,

  GET_DOCTOR_ID,
  GET_DOCTOR_ID_SUCCESS,
  GET_DOCTOR_ID_ERROR,
  GET_DOCTOR_ID_RESET,
  EMAIL_OTP,
  EMAIL_OTP_SUCCESS,
  EMAIL_OTP_ERROR,
  EMAIL_OTP_RESET,

  POST_DOCTOR_PIN,
  POST_DOCTOR_PIN_SUCCESS,
  POST_DOCTOR_PIN_ERROR,
  POST_DOCTOR_PIN_RESET,

} = require('./constants')

const initialState = {
  loggedInUser: {
    data: null,
    loading: false,
    error: null,
  },
  forgotPassword: {
    data: {},
    loading: false,
    error: null,
    message: '',
  },
  postUser: {
    data: null,
    loading: false,
    error: null,
  },
  importUser: {
    data: null,
    loading: false,
    error: null,
  },
  bulkUpdateUser: {
    data: null,
    loading: false,
    error: null,
  },
  allUsersList: {
    data: null,
    loading: false,
    error: null,
  },
  singleUser: {
    data: null,
    loading: false,
    error: null,
  },
  updateUser: {
    data: null,
    loading: false,
    error: null,
  },
  deleteUser: {
    data: null,
    loading: false,
    error: null,
  },
  adminDoctorsList: {
    data: null,
    loading: false,
    error: null,
  },
  adminDoctor: {
    data: null,
    loading: false,
    error: null,
  },
  createAdminDoctor: {
    data: null,
    loading: false,
    error: null,
  },
  updateAdminDoctor: {
    data: null,
    loading: false,
    error: null,
  },
  updateAdminDoctorStatus: {
    data: null,
    loading: false,
    error: null,
  },
  postAdminDoctorDigitalSig: {
    data: null,
    loading: false,
    error: null,
  },
  revokeAdminDoctorDigitalSig: {
    data: null,
    loading: false,
    error: null,
  },
  postAdminDoctorAuthPin: {
    data: null,
    loading: false,
    error: null,
  },
  postAdminDoctorSpecs: {
    data: null,
    loading: false,
    error: null,
  },
  deleteAdminDoctor: {
    data: null,
    loading: false,
    error: null,
  },
  adminPanelUsersList: {
    data: null,
    loading: false,
    error: null,
  },
  singleAdminPanelUser: {
    data: null,
    loading: false,
    error: null,
  },
  createAdminPanelUser: {
    data: null,
    loading: false,
    error: null,
  },
  updateAdminPanelUser: {
    data: null,
    loading: false,
    error: null,
  },
  profile: {
    data: {},
    loading: false,
    error: false,
    message: '',
  },
  emailOtp: {
    data: {},
    loading: false,
    error: null,
    message: '',
  },
  updateProfile: {
    data: {},
    loading: false,
    error: false,
  },
  postDocDigitalInfo: {
    data: null,
    loading: false,
    error: null,
  },
  userLogin: {
    data: {},
    loading: false,
    error: null,
    message: '',
  },
  userRegisteration: {
    data: {},
    loading: false,
    error: null,
    message: '',
  },
  appleLogin: {
    data: {},
    loading: false,
    error: null,
    message: '',
  },
  loginGoogle: {
    data: {},
    loading: false,
    error: null,
    message: '',
  },
  validatePhoneNumber: {
    data: {},
    loading: false,
    error: null,
    message: '',
  },
  updateEmail: {
    data: {},
    loading: false,
    error: null,
    message: '',
  },
  updateNumber: {
    data: {},
    loading: false,
    error: null,
    message: '',
  },
  logout: {
    loading: false,
    error: null,
  },
  changePassword: {
    data: {},
    loading: false,
    error: null,
    message: '',
  },
  marketplaceChangePassword: {
    data: {},
    loading: false,
    error: null,
    message: '',
  },
  getDoctorDetailsState: {
    data: {},
    loading: false,
    error: null,
    message: '',
  },
  getDoctorIdState: {
    data: {},
    loading: false,
    error: null,
    message: '',
  },
  postDoctorPin: {
    data: null,
    loading: false,
    error: null,
  },
}

module.exports = createReducer(
  {
      ////Email -Otp///
      [EMAIL_OTP]: (draft) => ({
        emailOtp: {
          ...draft.emailOtp,
          loading: true,
          error: null,
          message: '',
        },
      }),
      [EMAIL_OTP_SUCCESS]: (draft, action) => ({
        emailOtp: {
          ...draft.emailOtp,
          loading: false,
          data: action.payload.sessionId,
        },
      }),
      [EMAIL_OTP_ERROR]: (draft, action) => ({
        emailOtp: {
          ...draft.emailOtp,
          loading: false,
          error: action.payload.error,
          message: action.payload.message,
        },
      }),
      [EMAIL_OTP_RESET]: () => ({
        emailOtp: { ...initialState.emailOtp },
      }),
  
      ///
  
    [FORGOT_PASSWORD]: draft => ({
      forgotPassword: {
        ...draft.forgotPassword,
        loading: true,
        error: null,
        message: '',
      },
    }),
    [FORGOT_PASSWORD_SUCCESS]: (draft, action) => ({
      forgotPassword: {
        ...draft.forgotPassword,
        loading: false,
        data: action.payload.sessionId,
      },
    }),
    [FORGOT_PASSWORD_ERROR]: (draft, action) => ({
      forgotPassword: {
        ...draft.forgotPassword,
        loading: false,
        error: action.payload.error,
        message: action.payload.message,
      },
    }),
    [FORGOT_PASSWORD_RESET]: () => ({
      forgotPassword: { ...initialState.forgotPassword },
    }),

    [GET_LOGGED_IN_USER]: draft => ({
      loggedInUser: {
        ...draft.loggedInUser,
        loading: true,
        error: null,
        data: null,
      },
    }),
    [GET_LOGGED_IN_USER_SUCCESS]: (draft, action) => ({
      loggedInUser: {
        ...draft.loggedInUser,
        loading: false,
        data: action.payload.user,
      },
    }),
    [GET_LOGGED_IN_USER_ERROR]: (draft, action) => ({
      loggedInUser: {
        ...draft.loggedInUser,
        loading: false,
        error: action.payload.error,
      },
    }),
    [GET_LOGGED_IN_USER_RESET]: () => ({
      loggedInUser: { ...initialState.loggedInUser },
    }),

    [POST_USER]: draft => ({
      postUser: {
        ...draft.postUser,
        data: null,
        loading: true,
        error: null,
      },
    }),
    [POST_USER_SUCCESS]: (draft, action) => ({
      postUser: {
        ...draft.postUser,
        loading: false,
        data: action.payload.data,
      },
    }),
    [POST_USER_ERROR]: (draft, action) => ({
      postUser: {
        ...draft.postUser,
        loading: false,
        error: action.payload.error,
      },
    }),
    [POST_USER_RESET]: () => ({
      postUser: { ...initialState.postUser },
    }),

    [IMPORT_USER]: draft => ({
      importUser: {
        ...draft.importUser,
        data: null,
        loading: true,
        error: null,
      },
    }),
    [IMPORT_USER_SUCCESS]: (draft, action) => ({
      importUser: {
        ...draft.importUser,
        loading: false,
        data: action.payload.data,
      },
    }),
    [IMPORT_USER_ERROR]: (draft, action) => ({
      importUser: {
        ...draft.importUser,
        loading: false,
        error: action.payload.error,
      },
    }),
    [IMPORT_USER_RESET]: () => ({
      importUser: { ...initialState.importUser },
    }),
    
    [BULK_UPDATE_USER]: draft => ({
      bulkUpdateUser: {
        ...draft.bulkUpdateUser,
        data: null,
        loading: true,
        error: null,
      },
    }),
    [BULK_UPDATE_USER_SUCCESS]: (draft, action) => ({
      bulkUpdateUser: {
        ...draft.bulkUpdateUser,
        loading: false,
        data: action.payload.data,
      },
    }),
    [BULK_UPDATE_USER_ERROR]: (draft, action) => ({
      bulkUpdateUser: {
        ...draft.bulkUpdateUser,
        loading: false,
        error: action.payload.error,
      },
    }),
    [BULK_UPDATE_USER_RESET]: () => ({
      bulkUpdateUser: { ...initialState.bulkUpdateUser },
    }),

    [GET_ALL_USERS]: draft => ({
      allUsersList: {
        ...draft.allUsersList,
        data: null,
        loading: true,
        error: null,
      },
    }),
    [GET_ALL_USERS_SUCCESS]: (draft, action) => ({
      allUsersList: {
        ...draft.allUsersList,
        loading: false,
        data: action.payload.data,
      },
    }),
    [GET_ALL_USERS_ERROR]: (draft, action) => ({
      allUsersList: {
        ...draft.allUsersList,
        loading: false,
        error: action.payload.error,
      },
    }),
    [GET_ALL_USERS_RESET]: () => ({
      allUsersList: { ...initialState.allUsersList },
    }),

    [GET_SINGLE_USER]: draft => ({
      singleUser: {
        ...draft.singleUser,
        data: null,
        loading: true,
        error: null,
      },
    }),
    [GET_SINGLE_USER_SUCCESS]: (draft, action) => ({
      singleUser: {
        ...draft.singleUser,
        loading: false,
        data: action.payload.data,
      },
    }),
    [GET_SINGLE_USER_ERROR]: (draft, action) => ({
      singleUser: {
        ...draft.singleUser,
        loading: false,
        error: action.payload.error,
      },
    }),
    [GET_SINGLE_USER_RESET]: () => ({
      singleUser: { ...initialState.singleUser },
    }),

    [UPDATE_USER]: draft => ({
      updateUser: {
        ...draft.updateUser,
        data: null,
        loading: true,
        error: null,
      },
    }),
    [UPDATE_USER_SUCCESS]: (draft, action) => ({
      updateUser: {
        ...draft.updateUser,
        loading: false,
        data: action.payload.data,
      },
    }),
    [UPDATE_USER_ERROR]: (draft, action) => ({
      updateUser: {
        ...draft.updateUser,
        loading: false,
        error: action.payload.error,
      },
    }),
    [UPDATE_USER_RESET]: () => ({
      updateUser: { ...initialState.updateUser },
    }),

    [DELETE_USER]: draft => ({
      deleteUser: {
        ...draft.deleteUser,
        data: null,
        loading: true,
        error: null,
      },
    }),
    [DELETE_USER_SUCCESS]: (draft, action) => ({
      deleteUser: {
        ...draft.deleteUser,
        loading: false,
        data: action.payload.data,
      },
    }),
    [DELETE_USER_ERROR]: (draft, action) => ({
      deleteUser: {
        ...draft.deleteUser,
        loading: false,
        error: action.payload.error,
      },
    }),
    [DELETE_USER_RESET]: () => ({
      deleteUser: { ...initialState.deleteUser },
    }),

    [GET_ADMIN_DOCTORS_LIST]: draft => ({
      adminDoctorsList: {
        ...draft.adminDoctorsList,
        data: null,
        loading: true,
        error: null,
      },
    }),
    [GET_ADMIN_DOCTORS_LIST_SUCCESS]: (draft, action) => ({
      adminDoctorsList: {
        ...draft.adminDoctorsList,
        loading: false,
        data: action.payload.data,
      },
    }),
    [GET_ADMIN_DOCTORS_LIST_ERROR]: (draft, action) => ({
      adminDoctorsList: {
        ...draft.adminDoctorsList,
        loading: false,
        error: action.payload.error,
      },
    }),
    [GET_ADMIN_DOCTORS_LIST_RESET]: () => ({
      adminDoctorsList: { ...initialState.adminDoctorsList },
    }),

    [GET_ADMIN_DOCTOR]: draft => ({
      adminDoctor: {
        ...draft.adminDoctor,
        data: null,
        loading: true,
        error: null,
      },
    }),
    [GET_ADMIN_DOCTOR_SUCCESS]: (draft, action) => ({
      adminDoctor: {
        ...draft.adminDoctor,
        loading: false,
        data: action.payload.data,
      },
    }),
    [GET_ADMIN_DOCTOR_ERROR]: (draft, action) => ({
      adminDoctor: {
        ...draft.adminDoctor,
        loading: false,
        error: action.payload.error,
      },
    }),
    [GET_ADMIN_DOCTOR_RESET]: () => ({
      adminDoctor: { ...initialState.adminDoctor },
    }),

    [CREATE_ADMIN_DOCTOR]: draft => ({
      createAdminDoctor: {
        ...draft.createAdminDoctor,
        data: null,
        loading: true,
        error: null,
      },
    }),
    [CREATE_ADMIN_DOCTOR_SUCCESS]: (draft, action) => ({
      createAdminDoctor: {
        ...draft.createAdminDoctor,
        loading: false,
        data: action.payload.data,
      },
    }),
    [CREATE_ADMIN_DOCTOR_ERROR]: (draft, action) => ({
      createAdminDoctor: {
        ...draft.createAdminDoctor,
        loading: false,
        error: action.payload.error,
      },
    }),
    [CREATE_ADMIN_DOCTOR_RESET]: () => ({
      createAdminDoctor: { ...initialState.createAdminDoctor },
    }),

    [UPDATE_ADMIN_DOCTOR]: draft => ({
      updateAdminDoctor: {
        ...draft.updateAdminDoctor,
        data: null,
        loading: true,
        error: null,
      },
    }),
    [UPDATE_ADMIN_DOCTOR_SUCCESS]: (draft, action) => ({
      updateAdminDoctor: {
        ...draft.updateAdminDoctor,
        loading: false,
        data: action.payload.data,
      },
    }),
    [UPDATE_ADMIN_DOCTOR_ERROR]: (draft, action) => ({
      updateAdminDoctor: {
        ...draft.updateAdminDoctor,
        loading: false,
        error: action.payload.error,
      },
    }),
    [UPDATE_ADMIN_DOCTOR_RESET]: () => ({
      deleteAdminDoctor: { ...initialState.deleteAdminDoctor },
    }),

    [GET_ALL_ADMIN_PANEL_USERS]: draft => ({
      adminPanelUsersList: {
        ...draft.adminPanelUsersList,
        data: null,
        loading: true,
        error: null,
      },
    }),
    [GET_ALL_ADMIN_PANEL_USERS_SUCCESS]: (draft, action) => ({
      adminPanelUsersList: {
        ...draft.adminPanelUsersList,
        loading: false,
        data: action.payload.data,
      },
    }),
    [GET_ALL_ADMIN_PANEL_USERS_ERROR]: (draft, action) => ({
      adminPanelUsersList: {
        ...draft.adminPanelUsersList,
        loading: false,
        error: action.payload.error,
      },
    }),
    [GET_ALL_ADMIN_PANEL_USERS_RESET]: () => ({
      adminPanelUsersList: { ...initialState.adminPanelUsersList },
    }),

    [GET_SINGLE_ADMIN_PANEL_USER]: draft => ({
      singleAdminPanelUser: {
        ...draft.singleAdminPanelUser,
        data: null,
        loading: true,
        error: null,
      },
    }),
    [GET_SINGLE_ADMIN_PANEL_USER_SUCCESS]: (draft, action) => ({
      singleAdminPanelUser: {
        ...draft.singleAdminPanelUser,
        loading: false,
        data: action.payload.data,
      },
    }),
    [GET_SINGLE_ADMIN_PANEL_USER_ERROR]: (draft, action) => ({
      singleAdminPanelUser: {
        ...draft.singleAdminPanelUser,
        loading: false,
        error: action.payload.error,
      },
    }),
    [GET_SINGLE_ADMIN_PANEL_USER_RESET]: () => ({
      singleAdminPanelUser: { ...initialState.singleAdminPanelUser },
    }),

    [CREATE_ADMIN_PANEL_USER]: draft => ({
      createAdminPanelUser: {
        ...draft.createAdminPanelUser,
        data: null,
        loading: true,
        error: null,
      },
    }),
    [CREATE_ADMIN_PANEL_USER_SUCCESS]: (draft, action) => ({
      createAdminPanelUser: {
        ...draft.createAdminPanelUser,
        loading: false,
        data: action.payload.data,
      },
    }),
    [CREATE_ADMIN_PANEL_USER_ERROR]: (draft, action) => ({
      createAdminPanelUser: {
        ...draft.createAdminPanelUser,
        loading: false,
        error: action.payload.error,
      },
    }),
    [CREATE_ADMIN_PANEL_USER_RESET]: () => ({
      createAdminPanelUser: { ...initialState.createAdminPanelUser },
    }),

    [UPDATE_ADMIN_PANEL_USER]: draft => ({
      updateAdminPanelUser: {
        ...draft.updateAdminPanelUser,
        data: null,
        loading: true,
        error: null,
      },
    }),
    [UPDATE_ADMIN_PANEL_USER_SUCCESS]: (draft, action) => ({
      updateAdminPanelUser: {
        ...draft.updateAdminPanelUser,
        loading: false,
        data: action.payload.data,
      },
    }),
    [UPDATE_ADMIN_PANEL_USER_ERROR]: (draft, action) => ({
      updateAdminPanelUser: {
        ...draft.updateAdminPanelUser,
        loading: false,
        error: action.payload.error,
      },
    }),
    [UPDATE_ADMIN_PANEL_USER_RESET]: () => ({
      updateAdminPanelUser: { ...initialState.updateAdminPanelUser },
    }),

    [UPDATE_ADMIN_DOCTOR_STATUS]: draft => ({
      updateAdminDoctorStatus: {
        ...draft.updateAdminDoctorStatus,
        data: null,
        loading: true,
        error: null,
      },
    }),
    [UPDATE_ADMIN_DOCTOR_STATUS_SUCCESS]: (draft, action) => ({
      updateAdminDoctorStatus: {
        ...draft.updateAdminDoctorStatus,
        loading: false,
        data: action.payload.data,
      },
    }),
    [UPDATE_ADMIN_DOCTOR_STATUS_ERROR]: (draft, action) => ({
      updateAdminDoctorStatus: {
        ...draft.updateAdminDoctorStatus,
        loading: false,
        error: action.payload.error,
      },
    }),
    [UPDATE_ADMIN_DOCTOR_STATUS_RESET]: () => ({
      updateAdminDoctorStatus: { ...initialState.updateAdminDoctorStatus },
    }),

    [POST_ADMIN_DOCTOR_DIGITAL_SIG]: draft => ({
      postAdminDoctorDigitalSig: {
        ...draft.postAdminDoctorDigitalSig,
        data: null,
        loading: true,
        error: null,
      },
    }),
    [POST_ADMIN_DOCTOR_DIGITAL_SIG_SUCCESS]: (draft, action) => ({
      postAdminDoctorDigitalSig: {
        ...draft.postAdminDoctorDigitalSig,
        loading: false,
        data: action.payload.data,
      },
    }),
    [POST_ADMIN_DOCTOR_DIGITAL_SIG_ERROR]: (draft, action) => ({
      postAdminDoctorDigitalSig: {
        ...draft.postAdminDoctorDigitalSig,
        loading: false,
        error: action.payload.error,
      },
    }),
    [POST_ADMIN_DOCTOR_DIGITAL_SIG_RESET]: () => ({
      postAdminDoctorDigitalSig: { ...initialState.postAdminDoctorDigitalSig },
    }),

    [POST_ADMIN_DOCTOR_AUTH_PIN]: draft => ({
      postAdminDoctorAuthPin: {
        ...draft.postAdminDoctorAuthPin,
        data: null,
        loading: true,
        error: null,
      },
    }),
    [POST_ADMIN_DOCTOR_AUTH_PIN_SUCCESS]: (draft, action) => ({
      postAdminDoctorAuthPin: {
        ...draft.postAdminDoctorAuthPin,
        loading: false,
        data: action.payload.data,
      },
    }),
    [POST_ADMIN_DOCTOR_AUTH_PIN_ERROR]: (draft, action) => ({
      postAdminDoctorAuthPin: {
        ...draft.postAdminDoctorAuthPin,
        loading: false,
        error: action.payload.error,
      },
    }),
    [POST_ADMIN_DOCTOR_AUTH_PIN_RESET]: () => ({
      postAdminDoctorAuthPin: { ...initialState.postAdminDoctorAuthPin },
    }),

    [REVOKE_ADMIN_DOCTOR_DIGITAL_SIG]: draft => ({
      revokeAdminDoctorDigitalSig: {
        ...draft.revokeAdminDoctorDigitalSig,
        data: null,
        loading: true,
        error: null,
      },
    }),
    [REVOKE_ADMIN_DOCTOR_DIGITAL_SIG_SUCCESS]: (draft, action) => ({
      revokeAdminDoctorDigitalSig: {
        ...draft.revokeAdminDoctorDigitalSig,
        loading: false,
        data: action.payload.data,
      },
    }),
    [REVOKE_ADMIN_DOCTOR_DIGITAL_SIG_ERROR]: (draft, action) => ({
      revokeAdminDoctorDigitalSig: {
        ...draft.revokeAdminDoctorDigitalSig,
        loading: false,
        error: action.payload.error,
      },
    }),
    [REVOKE_ADMIN_DOCTOR_DIGITAL_SIG_RESET]: () => ({
      revokeAdminDoctorDigitalSig: { ...initialState.revokeAdminDoctorDigitalSig },
    }),

    [POST_ADMIN_DOCTOR_SPECS]: draft => ({
      postAdminDoctorSpecs: {
        ...draft.postAdminDoctorSpecs,
        data: null,
        loading: true,
        error: null,
      },
    }),
    [POST_ADMIN_DOCTOR_SPECS_SUCCESS]: (draft, action) => ({
      postAdminDoctorSpecs: {
        ...draft.postAdminDoctorSpecs,
        loading: false,
        data: action.payload.data,
      },
    }),
    [POST_ADMIN_DOCTOR_SPECS_ERROR]: (draft, action) => ({
      postAdminDoctorSpecs: {
        ...draft.postAdminDoctorSpecs,
        loading: false,
        error: action.payload.error,
      },
    }),
    [POST_ADMIN_DOCTOR_SPECS_RESET]: () => ({
      postAdminDoctorSpecs: { ...initialState.postAdminDoctorSpecs },
    }),

    [DELETE_ADMIN_DOCTOR]: draft => ({
      deleteAdminDoctor: {
        ...draft.deleteAdminDoctor,
        data: null,
        loading: true,
        error: null,
      },
    }),
    [DELETE_ADMIN_DOCTOR_SUCCESS]: (draft, action) => ({
      deleteAdminDoctor: {
        ...draft.deleteAdminDoctor,
        loading: false,
        data: action.payload.data,
      },
    }),
    [DELETE_ADMIN_DOCTOR_ERROR]: (draft, action) => ({
      deleteAdminDoctor: {
        ...draft.deleteAdminDoctor,
        loading: false,
        error: action.payload.error,
      },
    }),
    [DELETE_ADMIN_DOCTOR_RESET]: () => ({
      deleteAdminDoctor: { ...initialState.deleteAdminDoctor },
    }),

    [GET_PROFILE]: draft => ({
      profile: {
        ...draft.profile,
        loading: true,
        error: false,
        message: '',
      },
    }),
    [GET_PROFILE_SUCCESS]: (draft, action) => ({
      profile: {
        ...draft.profile,
        loading: false,
        data: action.payload.user,
      },
    }),
    [GET_PROFILE_ERROR]: (draft, action) => ({
      profile: {
        ...draft.profile,
        loading: false,
        error: action.payload.error,
        message: action.payload.message,
      },
    }),
    [GET_PROFILE_RESET]: () => ({
      profile: { ...initialState.profile },
    }),

    [UPDATE_PROFILE]: draft => ({
      updateProfile: {
        ...draft.updateProfile,
        loading: true,
        error: false,
        message: '',
      },
    }),
    [UPDATE_PROFILE_SUCCESS]: (draft, action) => ({
      updateProfile: {
        ...draft.updateProfile,
        loading: false,
        data: action.payload.user,
      },
    }),
    [UPDATE_PROFILE_ERROR]: (draft, action) => ({
      updateProfile: {
        ...draft.updateProfile,
        loading: false,
        error: action.payload.error,
        message: action.payload.message,
      },
    }),
    [UPDATE_PROFILE_RESET]: () => ({
      updateProfile: { ...initialState.updateProfile },
    }),

    [POST_DOC_DIGITAL_INFO]: draft => ({
      postDocDigitalInfo: {
        ...draft.postDocDigitalInfo,
        loading: true,
        error: null,
      },
    }),
    [POST_DOC_DIGITAL_INFO_SUCCESS]: (draft, action) => ({
      postDocDigitalInfo: {
        ...draft.postDocDigitalInfo,
        loading: false,
        data: action.payload.info,
      },
    }),
    [POST_DOC_DIGITAL_INFO_ERROR]: (draft, action) => ({
      postDocDigitalInfo: {
        ...draft.postDocDigitalInfo,
        loading: false,
        error: action.payload.error,
      },
    }),
    [POST_DOC_DIGITAL_INFO_RESET]: () => ({
      postDocDigitalInfo: { ...initialState.postDocDigitalInfo },
    }),

    [USER_LOGIN]: draft => ({
      userLogin: {
        ...draft.userLogin,
        loading: true,
        error: null,
        message: '',
      },
    }),
    [USER_LOGIN_SUCCESS]: (draft, action) => ({
      userLogin: {
        ...draft.userLogin,
        loading: false,
        data: action.payload.user,
      },
    }),
    [USER_LOGIN_ERROR]: (draft, action) => ({
      userLogin: {
        ...draft.userLogin,
        loading: false,
        error: action.payload.error,
        message: action.payload.message,
      },
    }),
    [USER_LOGIN_RESET]: () => ({
      userLogin: { ...initialState.userLogin },
    }),

    [USER_REGISTRATION]: draft => ({
      userRegisteration: {
        ...draft.userRegisteration,
        loading: true,
        error: null,
        message: '',
      },
    }),
    [USER_REGISTRATION_SUCCESS]: (draft, action) => ({
      userRegisteration: {
        ...draft.userRegisteration,
        loading: false,
        data: action.payload.user,
      },
    }),
    [USER_REGISTRATION_ERROR]: (draft, action) => ({
      userRegisteration: {
        ...draft.userRegisteration,
        loading: false,
        error: action.payload.error,
        message: action.payload.message,
      },
    }),
    [USER_REGISTRATION_RESET]: () => ({
      userRegisteration: { ...initialState.userRegisteration },
    }),
    [APPLE_LOGIN]: draft => ({
      appleLogin: {
        ...draft.appleLogin,
        loading: true,
        error: null,
        message: '',
      },
    }),
    [APPLE_LOGIN_SUCCESS]: (draft, action) => ({
      appleLogin: {
        ...draft.appleLogin,
        loading: false,
        data: action.payload.user,
      },
    }),
    [APPLE_LOGIN_ERROR]: (draft, action) => ({
      appleLogin: {
        ...draft.appleLogin,
        loading: false,
        error: action.payload.error,
        message: action.payload.message,
      },
    }),
    [APPLE_LOGIN_RESET]: () => ({
      appleLogin: { ...initialState.appleLogin },
    }),
    [LOGIN_GOOGLE]: draft => ({
      loginGoogle: {
        ...draft.loginGoogle,
        loading: true,
        error: null,
        message: '',
      },
    }),
    [LOGIN_GOOGLE_SUCCESS]: (draft, action) => ({
      loginGoogle: {
        ...draft.loginGoogle,
        loading: false,
        data: action.payload.user,
      },
    }),
    [LOGIN_GOOGLE_ERROR]: (draft, action) => ({
      loginGoogle: {
        ...draft.loginGoogle,
        loading: false,
        error: action.payload.error,
        message: action.payload.message,
      },
    }),
    [LOGIN_GOOGLE_RESET]: () => ({
      loginGoogle: { ...initialState.loginGoogle },
    }),
    [NUMBER_VALIDATION]: draft => ({
      validatePhoneNumber: {
        ...draft.validatePhoneNumber,
        loading: true,
        error: null,
        message: '',
      },
    }),
    [NUMBER_VALIDATION_SUCCESS]: (draft, action) => ({
      validatePhoneNumber: {
        ...draft.validatePhoneNumber,
        loading: false,
        data: action.payload.sessionId,
      },
    }),
    [NUMBER_VALIDATION_ERROR]: (draft, action) => ({
      validatePhoneNumber: {
        ...draft.validatePhoneNumber,
        loading: false,
        error: action.payload.error,
        message: action.payload.message,
      },
    }),
    [NUMBER_VALIDATION_RESET]: () => ({
      validatePhoneNumber: { ...initialState.validatePhoneNumber },
    }),

    [USER_LOGOUT]: draft => ({
      logout: {
        ...draft.logout,
        loading: true,
        error: null,
      },
    }),
    [USER_LOGOUT_SUCCESS]: draft => ({
      logout: {
        ...draft.logout,
        loading: false,
      },
    }),
    [USER_LOGOUT_ERROR]: (draft, action) => ({
      logout: {
        ...draft.logout,
        loading: false,
        error: action.payload.error,
      },
    }),
    [UPDATE_EMAIL]: draft => ({
      updateEmail: {
        ...draft.updateEmail,
        loading: true,
        error: null,
        message: '',
      },
    }),
    [UPDATE_EMAIL_SUCCESS]: (draft, action) => ({
      updateEmail: {
        ...draft.updateEmail,
        loading: false,
        data: action.payload.data,
      },
    }),
    [UPDATE_EMAIL_ERROR]: (draft, action) => ({
      updateEmail: {
        ...draft.updateEmail,
        loading: false,
        error: action.payload.error,
        message: action.payload.message,
      },
    }),
    [UPDATE_EMAIL_RESET]: () => ({
      updateEmail: { ...initialState.updateEmail },
    }),
    [UPDATE_NUMBER]: draft => ({
      updateNumber: {
        ...draft.updateNumber,
        loading: true,
        error: null,
        message: '',
      },
    }),
    [UPDATE_NUMBER_SUCCESS]: (draft, action) => ({
      updateNumber: {
        ...draft.updateNumber,
        loading: false,
        data: action.payload.data,
      },
    }),
    [UPDATE_NUMBER_ERROR]: (draft, action) => ({
      updateNumber: {
        ...draft.updateNumber,
        loading: false,
        error: action.payload.error,
        message: action.payload.message,
      },
    }),
    [UPDATE_NUMBER_RESET]: () => ({
      updateNumber: { ...initialState.updateNumber },
    }),
    [PASSWORD_CHANGE]: draft => ({
      changePassword: {
        ...draft.changePassword,
        loading: true,
        error: null,
        message: '',
      },
    }),
    [PASSWORD_CHANGE_SUCCESS]: (draft, action) => ({
      changePassword: {
        ...draft.changePassword,
        loading: false,
        data: action.payload.data,
      },
    }),
    [PASSWORD_CHANGE_ERROR]: (draft, action) => ({
      changePassword: {
        ...draft.changePassword,
        loading: false,
        error: action.payload.error,
        message: action.payload.message,
      },
    }),
    [PASSWORD_CHANGE_RESET]: () => ({
      changePassword: { ...initialState.changePassword },
    }),
    [MARKETPLACE_PASSWORD_CHANGE]: draft => ({
      marketplaceChangePassword: {
        ...draft.marketplaceChangePassword,
        loading: true,
        error: null,
        message: '',
      },
    }),
    [MARKETPLACE_PASSWORD_CHANGE_SUCCESS]: (draft, action) => ({
      marketplaceChangePassword: {
        ...draft.marketplaceChangePassword,
        loading: false,
        data: action.payload.data,
      },
    }),
    [MARKETPLACE_PASSWORD_CHANGE_ERROR]: (draft, action) => ({
      marketplaceChangePassword: {
        ...draft.marketplaceChangePassword,
        loading: false,
        error: action.payload.error,
        message: action.payload.message,
      },
    }),
    [MARKETPLACE_PASSWORD_CHANGE_RESET]: () => ({
      marketplaceChangePassword: { ...initialState.marketplaceChangePassword },
    }),

    [GET_DOCTOR_DETAILS]: draft => ({
      getDoctorDetailsState: {
        ...draft.getDoctorDetailsState,
        data: {},
        loading: true,
        error: null,
        message: '',
      },
    }),
    [GET_DOCTOR_DETAILS_SUCCESS]: (draft, action) => ({
      getDoctorDetailsState: {
        ...draft.getDoctorDetailsState,
        loading: false,
        data: action.payload.data,
      },
    }),
    [GET_DOCTOR_DETAILS_ERROR]: (draft, action) => ({
      getDoctorDetailsState: {
        ...draft.getDoctorDetailsState,
        loading: false,
        error: action.payload.error,
        message: action.payload.message,
      },
    }),
    [GET_DOCTOR_DETAILS_RESET]: () => ({
      getDoctorDetailsState: { ...initialState.getDoctorDetailsState },
    }),

    [GET_DOCTOR_ID]: draft => ({
      getDoctorIdState: {
        ...draft.getDoctorIdState,
        data: {},
        loading: true,
        error: null,
        message: '',
      },
    }),
    [GET_DOCTOR_ID_SUCCESS]: (draft, action) => ({
      getDoctorIdState: {
        ...draft.getDoctorIdState,
        loading: false,
        data: action.payload.data,
      },
    }),
    [GET_DOCTOR_ID_ERROR]: (draft, action) => ({
      getDoctorIdState: {
        ...draft.getDoctorIdState,
        loading: false,
        error: action.payload.error,
        message: action.payload.message,
      },
    }),
    [GET_DOCTOR_ID_RESET]: () => ({
      getDoctorIdState: { ...initialState.getDoctorIdState },
    }),

    [POST_DOCTOR_PIN]: draft => ({
      postDoctorPin: {
        ...draft.postDoctorPin,
        data: null,
        loading: true,
        error: null,
      },
    }),
    [POST_DOCTOR_PIN_SUCCESS]: (draft, action) => ({
      postDoctorPin: {
        ...draft.postDoctorPin,
        loading: false,
        data: action.payload.data,
      },
    }),
    [POST_DOCTOR_PIN_ERROR]: (draft, action) => ({
      postDoctorPin: {
        ...draft.postDoctorPin,
        loading: false,
        error: action.payload.error,
      },
    }),
    [POST_DOCTOR_PIN_RESET]: () => ({
      postDoctorPin: { ...initialState.postDoctorPin },
    }),
  },
  initialState,
)